import { Fold } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Playlist2Items, _PlaylistGetter, } from "@discovery/sonic-api-ng-optics-gen/lib/playlist";
export * from "@discovery/sonic-api-ng-optics-gen/lib/playlist";
export const _Playlist2Videos = Fold.compose(_PlaylistGetter, _Playlist2Items, Res._Response());

